import React from "react";
import "./skills_lists.css";

function Skills_list() {
  return (
    <div className="full_cards">
      <div className="Skill_header">
        <h4>Skills</h4>
      </div>
      
        <div className="card-deck cardsss">
          <div className="card cardsss">
            <i className="devicon-html5-plain"></i>
            <p>HTML 5</p>
          </div>

          <div className="card cardsss">
            <i className="devicon-css3-plain"></i>
            <p>CSS 3</p>
          </div>

          <div className="card cardsss">
            <i className="devicon-javascript-plain"></i>
            <p>Javascript</p>
          </div>

          <div className="card cardsss">
            <i className="devicon-react-original"></i>
            <p>React js</p>
          </div>

          <div className="card cardsss">
            <i className="devicon-bootstrap-plain"></i>
            <p>Bootstrap</p>
          </div>
        </div>
      </div>
    
  );
}

export default Skills_list;
